export default __webpack_public_path__ + "static/media/check_date.c6f0d8fd.svg";